// extracted by mini-css-extract-plugin
export default {"contactInfoLabel":"Contacts_contactInfoLabel__99fvp","contactInfoValue":"Contacts_contactInfoValue__WnoQd"};